import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";

const Styles = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .react-datepicker-wrapper,
  .react-datepicker__input-container,
  .react-datepicker__input-container input {
    background-color: transparent;
    width: 100%;
  }

  // .react-datepicker__input-container,
  .react-datepicker__input-container input {
    border: solid 1px rgb(182, 182, 182);
    border-radius: 4px;
    font-size: 15px;
    padding: 10px;
  }
`;

export default function SchoolYearDatePicker({ schoolYear, setSchoolYear }) {
  const [schoolYearStart, setSchoolYearStart] = useState(
    schoolYear ? schoolYear.split("-")[0] : ""
  );
  const [schoolYearEnd, setSchoolYearEnd] = useState(
    schoolYear ? schoolYear.split("-")[1] : ""
  );
  const [warning, setWarning] = useState("");

  useEffect(() => {
    if (schoolYearStart > schoolYearEnd) {
      setSchoolYearStart();
      setSchoolYearEnd();
      setWarning(`Year Start shouldn't be greater than Year End`);
      setTimeout(() => {
        setWarning("");
      }, 3000);
    }

    if (schoolYearStart) {
      setSchoolYear(`${schoolYearStart}-${schoolYearEnd}`);
    } else {
      setSchoolYear();
    }
  }, [schoolYearStart, schoolYearEnd]);

  return (
    <>
      <Styles>
        <DatePicker
          isClearable
          className="datepicker"
          placeholderText="Start Year"
          selected={schoolYearStart ? new Date(schoolYearStart, 0, 1) : null}
          onChange={(date) => {
            setSchoolYearStart(date?.getFullYear());
            // eslint-disable-next-line no-unsafe-optional-chaining
            setSchoolYearEnd(date?.getFullYear() + 1);
          }}
          dateFormat="yyyy"
          showYearPicker
          scrollableYearDropdown
          yearDropdownScrollOffset={9}
        />
        <Typography sx={{ mx: 2, fontWeight: "bold", color: "gray" }}>
          -
        </Typography>
        <DatePicker
          className="datepicker"
          placeholderText="Start End"
          selected={schoolYearEnd ? new Date(schoolYearEnd, 0, 1) : null}
          dateFormat="yyyy"
          disabled
          showYearPicker
          scrollableYearDropdown
          yearDropdownScrollOffset={9}
        />
      </Styles>
      <Typography sx={{ fontSize: "15px", color: "gray", fontStyle: "italic" }}>
        {warning}
      </Typography>
    </>
  );
}
